buyBonusPopup = {};

buyBonusPopup.buyBonusLow = false;
buyBonusPopup.buyBonusHigh = false;
buyBonusPopup.buyBonusMystery = false;

buyBonusPopup.infoText = undefined;

buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground');

  buyBonusPopup.closeButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:closeButton');

  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeSelectionContainer:stakePrevious'
  );

  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeSelectionContainer:stakeNext'
  );

  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeSelectionContainer:baseStakeText'
  );

  //buy buttons
  buyBonusPopup.lowerFreeSpinsButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel1:buyButton1'
  );
  buyBonusPopup.higherFreeSpinsButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel2:buyButton2'
  );
  buyBonusPopup.mysteryFreeSpinsButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel3:buyButton3'
  );

  //total cost panels
  buyBonusPopup.totalCostPanel1 = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel1'
  );
  buyBonusPopup.totalCostPanel2 = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel2'
  );
  buyBonusPopup.totalCostPanel3 = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel3'
  );

  // total cost texts
  buyBonusPopup.lowerFreeSpinsCostText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel1:totalCostPanel1Text'
  );

  buyBonusPopup.higherFreeSpinsCostText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel2:totalCostPanel2Text'
  );

  buyBonusPopup.mysteryFreeSpinsCostText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:totalCostPanel3:totalCostPanel3Text'
  );

  buyBonusPopup.lowerFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesLower;
  buyBonusPopup.higherFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesHigher;
  buyBonusPopup.mysteryFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesMystery;
};

buyBonusPopup.onClickedYesLower = async () => {
  soundManager.play('buyBonusClick');

  buyBonusPopup.buyBonusLow = true;
  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMystery = false;

  buyBonusPopup.closeButton.visible = false;
  buyBonusPopup.closeButton.enableButton(false);
  buyBonusPopup.onClickedYes();
};

buyBonusPopup.onClickedYesHigher = async () => {
  soundManager.play('buyBonusClick');

  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.buyBonusHigh = true;
  buyBonusPopup.buyBonusMystery = false;

  buyBonusPopup.closeButton.visible = false;
  buyBonusPopup.closeButton.enableButton(false);
  buyBonusPopup.onClickedYes();
};

buyBonusPopup.onClickedYesMystery = async () => {
  soundManager.play('buyBonusClick');

  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMystery = true;

  buyBonusPopup.closeButton.visible = false;
  buyBonusPopup.closeButton.enableButton(false);
  buyBonusPopup.onClickedYes();
};

buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;
  gameController.justEnteredBuyABonus = true;

  buyBonusPopup.closeButton.visible = true;
  buyBonusPopup.closeButton.enableButton(true);

  const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
  const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MYSTERY.coinSizes;
  const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

  // combine all the stakes and remove duplicates - then sort
  // this might all go wrong with stake indexes as some stakes will only be in one mode and not the other
  buyBonusPopup.allStakesCombined = lowFreeSpinsStakes.concat(
    medFreeSpinStakes.filter(function (el) {
      medFreeSpinStakes.indexOf(el) === -1;
    }),
    highFreeSpinStakes.filter(function (el) {
      highFreeSpinStakes.indexOf(el) === -1;
    })
  );

  buyBonusPopup.allStakesCombined.sort(function (a, b, c) {
    return a - b - c;
  });

  // if the buy a bonus default stakes are different we choose the lowest of the two - game design
  const MedFreeSpinsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MYSTERY.defaultAmountPerLine;
  const fsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.defaultAmountPerLine;

  let defaultToUse = MedFreeSpinsDefault;

  if (MedFreeSpinsDefault !== fsDefault) {
    console.log('WARNING: Default buy a bonus stakes differ between modes');
    defaultToUse = Math.min(MedFreeSpinsDefault, fsDefault);
  }

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  const crtBaseStake = gameController.globalHelperGetBaseStake();
  const stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  const index = bonusBuyStakes.findIndex((stake) => stake * numLines === crtBaseStake);

  if (index !== -1) {
    buyBonusPopup.combinedStakeIndex = index;
  } else {
    buyBonusPopup.combinedStakeIndex = bonusBuyStakes.length - 1;
  }

  buyBonusPopup.updatePopup();

  resourceManager.getContainer('buyABonusContainer').visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.stakeIndex === -1) {
    // Something went wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);

    buyBonusPopup.freeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.combinedStakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1);

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid for each buy a bonus mode
    const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
    const mysteryFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MYSTERY.coinSizes;
    const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let highFreespinsStakeExists = highFreeSpinStakes.includes(stakeToFind);
    let mysteryFreespinsStakeExists = mysteryFreeSpinStakes.includes(stakeToFind);
    let lowSpinsStakeExists = lowFreeSpinsStakes.includes(stakeToFind);

    //costs
    const costHighFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    buyBonusPopup.higherFreeSpinsCostText.setText(gdk.formatCurrency(costHighFreespins));
    buyBonusPopup.higherFreeSpinsButton.enableButton(
      buyBonusPopup.balance >= costHighFreespins && highFreespinsStakeExists
    );

    const costMysteryFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMystery;
    buyBonusPopup.mysteryFreeSpinsCostText.setText(gdk.formatCurrency(costMysteryFreespins));
    buyBonusPopup.mysteryFreeSpinsButton.enableButton(
      buyBonusPopup.balance >= costMysteryFreespins && mysteryFreespinsStakeExists
    );

    const costlowFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    buyBonusPopup.lowerFreeSpinsCostText.setText(gdk.formatCurrency(costlowFreespins));
    buyBonusPopup.lowerFreeSpinsButton.enableButton(buyBonusPopup.balance >= costlowFreespins && lowSpinsStakeExists);
  }
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play('buttonPressed');

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(buyBonusPopup.combinedStakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play('buttonPressed');

  buyBonusPopup.combinedStakeIndex = Math.max(buyBonusPopup.combinedStakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  buyBonusPopup.fadedMask.interactive = true;
  messageBus.subscribe('spinner:GameConfigEvent', buyBonusPopup.onGameConfig);
  messageBus.subscribe('common:BalanceEvent', buyBonusPopup.onBalanceEvent);
  messageBus.subscribe('game:modal', buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === 'Options menu open') {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.freeSpinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);

      // update the stake buttons
      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.freeSpinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }
  }
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  if (buyBonus) {
    soundManager.play('buyBonus');
  } else {
    soundManager.play('buttonPressed');
  }

  if (buyBonus) {
    buyBonusPopup.onStartBonusSpin();
  } else {
    // Not buying a bonus, so reset
  }

  buyBonusPopup.open = false;

  let reels = resourceManager.get('mainReelsContainer:slotContainer:reelContainer');
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  buyBonusPopup.callback(buyBonus);
};

buyBonusPopup.onStartBonusSpin = function () {
  gameController.inBuyABonus = true;

  gameController.stopCyclingWins();

  // Remove modal
  messageBus.post('game:modal', { data: 'buy_bonus_start' });

  let stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;

  // Reset win meter and total winnings when starting a new bonus buy
  gameData.winningsMeter.set(0);
  gameController.totalWinnings = 0;
  gameController.storedPayWinsData = undefined;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;

  // we should be ok to use the combined stake index as the button will be disabled if not an allowable stake
  let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  let bonusType;
  let buyCost;

  gameController.buyBonusLow = false;
  gameController.buyBonusMed = false;
  gameController.buyBonusHigh = false;

  if (buyBonusPopup.buyBonusHigh) {
    bonusType = 'BONUS_BUY_HIGH';
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    gameController.buyBonusHigh = true;
  } else if (buyBonusPopup.buyBonusMystery) {
    bonusType = 'BONUS_BUY_MYSTERY';
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMystery;
    gameController.buyBonusMystery = true;
  } else {
    bonusType = 'BONUS_BUY_LOW';
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    gameController.buyBonusLow = true;
  }

  gameData.bonusBuyStake = baseStake;
  stakeController.requestChangeStake(baseStake, bonusType);

  const bpl = baseStake / numLines;

  gameController.boughtBonus = true;

  // gameController.initNewSpin();

  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: numLines,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
        buyBonusLowActive: buyBonusPopup.buyBonusLow,
        buyBonusHighActive: buyBonusPopup.buyBonusHigh,
        buyBonusMysteryActive: buyBonusPopup.buyBonusMystery,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedFreeSpins = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;

  messageBus.post('game:modal', { data: 'buy_bonus_cancel' });

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.onInfo = function () {
  soundManager.play('buttonPressed');
  gameData.helpPageScroll.open();
};

buyBonusPopup.onStakeChanged = function (stake) {
  if (!buyBonusPopup.open && stake !== undefined) {
    if (gameData.stakes.indexOf(stake) !== -1) {
      // only save valid stakes
      gameController.currentNonBABStake = stake;
    }
  }
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  'buyBonusPopup',
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);

messageBus.subscribe('stake:stakeChanged', buyBonusPopup.onStakeChanged);
